module.exports = __webpack_public_path__ + "static/media/comment-alt-dots.d1328be7.svg";